var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',[_vm._t("content"),(_vm.showFooter)?_c('main-footer'):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }